@if (!isLoading) {
    @if (standalone) {
        <app-header/>
        <ion-content>
            <ng-container *ngTemplateOutlet="errorMessageDetails"></ng-container>
        </ion-content>
    } @else {
        <div>
            <ng-container *ngTemplateOutlet="errorMessageDetails"></ng-container>
        </div>
    }

    <ng-template #errorMessageDetails>
        <app-error-detail-template [error]="error!" (errorTypeUpdated)="updateErrorType($event)"
                                   [solveError]="solveError">
            <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.data"
                                   [content]="error!.data"/>
        </app-error-detail-template>
    </ng-template>
}
